<template>
	<!-- 参展企业 -->
	<div>
		<el-carousel indicator-position="outside" height="229px" :interval="3000" arrow="none" trigger="click">
			<el-carousel-item>
				<div class="exhibition_flex">
					<div class="exhibition_box" v-for="(itme,index) in exhibitionList" :class="index == 0? 'blue':''">
						<img :src="itme.url" class="exhibition_img" />
						<div class="hover_box">
							<div class="span_box">{{itme.title}}</div>
						</div>
					</div>
				</div>
			</el-carousel-item>

			<el-carousel-item>
				<div class="exhibition_flex">
					<div class="exhibition_box" v-for="(itme,index) in exhibitionListTwo">
						<img :src="itme.url" class="exhibition_img" />
						<div class="hover_box">
							<div class="span_box">{{itme.title}}</div>
						</div>
					</div>
				</div>
			</el-carousel-item>

			<el-carousel-item>
				<div class="exhibition_flex">
					<div class="exhibition_box" v-for="(itme,index) in exhibitionListThree">
						<img :src="itme.url" class="exhibition_img" />
						<div class="hover_box">
							<div class="span_box">{{itme.title}}</div>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>




	</div>
</template>

<script>
	export default {
		data() {
			return {
				exhibitionList: [{
						url: require('@/assets/exhibition/1.png'),
						title: '辉瑞投资有限公司',
						id: 1
					},
					{
						url: require('@/assets/exhibition/2.png'),
						title: '浙江医药股份有限公司',
						id: 2
					},
					{
						url: require('@/assets/exhibition/3.png'),
						title: '住友制药（苏州）有限公司',
						id: 3
					},
					{
						url: require('@/assets/exhibition/4.png'),
						title: '第一三共 （中国）投资有限公司',
						id: 4
					},
					{
						url: require('@/assets/exhibition/5.png'),
						title: '江苏恒瑞医药股份有限公司',
						id: 5
					},
					{
						url: require('@/assets/exhibition/6.png'),
						title: '瀚晖制药',
						id: 6
					},
					{
						url: require('@/assets/exhibition/7.png'),
						title: '深圳华润九新药业有限公司',
						id: 7
					},
					{
						url: require('@/assets/exhibition/8.png'),
						title: '嘉佑医药',
						id: 8
					},
					{
						url: require('@/assets/exhibition/9.png'),
						title: '正大天晴药业集团股份有限公司',
						id: 9
					},
					{
						url: require('@/assets/exhibition/10.png'),
						title: '武汉汇海医药有限公司',
						id: 10
					},
					{
						url: require('@/assets/exhibition/11.png'),
						title: ' 碧迪医疗器械（上海）有限公司',
						id: 11
					},
					{
						url: require('@/assets/exhibition/12.png'),
						title: '金匙医学',
						id: 12
					},
					{
						url: require('@/assets/exhibition/13.png'),
						title: '上海罗氏制药有限公司',
						id: 13
					},
					{
						url: require('@/assets/exhibition/14.png'),
						title: '微远基因',
						id: 14
					}, {
						url: require('@/assets/exhibition/15.png'),
						title: ' 苏州亿腾药品销售有限公司',
						id: 15
					},
					{
						url: require('@/assets/exhibition/16.png'),
						title: '江苏豪森药业集团有限公司',
						id: 16
					},
				],
				exhibitionListTwo: [{
						url: require('@/assets/exhibition/17.png'),
						title: '齐鲁制药有限公司',
						id: 17
					},
					{
						url: require('@/assets/exhibition/18.png'),
						title: '生物梅里埃',
						id: 18
					},
					{
						url: require('@/assets/exhibition/19.png'),
						title: '苏州大冢制药有限公司',
						id: 19
					},
					{
						url: require('@/assets/exhibition/20.png'),
						title: '重庆药友制药有限责任公司',
						id: 20
					},
					{
						url: require('@/assets/exhibition/21.png'),
						title: '石药控股集团有限公司',
						id: 21
					},
					{
						url: require('@/assets/exhibition/22.png'),
						title: '东北制药集团沈阳第一制药有限公司',
						id: 22
					},
					{
						url: require('@/assets/exhibition/23.png'),
						title: '杭州恒通医药有限公司',
						id: 23
					},
					{
						url: require('@/assets/exhibition/24.png'),
						title: '海南海灵化学制药有限公司',
						id: 24
					},
					{
						url: require('@/assets/exhibition/25.png'),
						title: '山西仟源医药集团股份有限公司',
						id: 25
					},
					{
						url: require('@/assets/exhibition/26.png'),
						title: '北京金山川',
						id: 26
					},
					{
						url: require('@/assets/exhibition/27.png'),
						title: ' 杭州中美华东制药有限公司',
						id: 27
					},
					{
						url: require('@/assets/exhibition/28.png'),
						title: '珠海迪尔生物工程有限公司',
						id: 28
					},
					{
						url: require('@/assets/exhibition/29.png'),
						title: '上海复星长征医学科学有限公司',
						id: 29
					},
					// {
					// 	url: require('@/assets/exhibition/18.png'),
					// 	title: '金域医学',
					// 	id: 18
					// },
					{
						url: require('@/assets/exhibition/30.png'),
						title: '金域医学',
						id: 30
					},
					{
						url: require('@/assets/exhibition/31.png'),
						title: ' 华北制药股份有限公司',
						id: 31
					},
					{
						url: require('@/assets/exhibition/32.png'),
						title: ' 湘北威尔曼制药企业',
						id: 32
					}
				],
				exhibitionListThree: [{
					url: require('@/assets/exhibition/33.png'),
					title: ' 锐翌生物科技',
					id: 33
				}]
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';

	.exhibition_flex {
		background-color: white;
		display: flex;
		flex-wrap: wrap;

	}

	.exhibition_box {
		width: 92px;
		height: 92px;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.2);
		overflow: hidden;
		padding: 10px;
		position: relative;

	}

	.exhibition_box:hover .hover_box {
		display: block;
	}

	.exhibition_img {
		width: 100%;
		margin-top: 50%;
		transform: translateY(-50%);
	}

	.blue {
		background-color: #cce8ff;
	}

	.hover_box {
		width: 112px;
		height: 112px;
		background-color: rgba(0, 0, 0, 0.7);
		// line-height: 150px;
		text-align: center;
		position: absolute;
		top: 0;
		left: 0;
		color: #fff;
		display: none;
		cursor: pointer;
		font-size: 14px;
	}

	.span_box {
		margin-top: 50%;
		transform: translateY(-50%);
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	// .el-carousel__item:nth-child(2n) {
	// 	background-color: #99a9bf;
	// }

	// .el-carousel__item:nth-child(2n+1) {
	// 	background-color: #d3dce6;
	// }
</style>
